import { Inject, Pipe, PipeTransform } from '@angular/core';
import { delay, from, Observable, of, switchMap } from 'rxjs';
import { DYNAMIC_COMPONENTS } from '@app/constants/dynamic-components.constants';
import { DOCUMENT } from '@angular/common';
import { environment } from '@src/environments/environment';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

/*import { LoggerService } from '@app/services/util-services/logger.service';*/

@Pipe({
  name: 'b2bDynamicLoaderPipe',
  standalone: true,
})
export class B2bDynamicLoaderPipe implements PipeTransform {
  constructor(
    @Inject(DOCUMENT) private readonly document,
    private b2bDeviceUtilService: B2bDeviceUtilService,
  ) {}

  transform(value: string, key?: string, timeout: number = 0): Observable<any> {
    const keys: string[] = [
      /*'india_s_fastest_growing_card_container',
      'discover_india_container',
      'you_stay_we_pay_11th_stay_container',
      'you_stay_we_pay_21st_stay_container',
      'introducing_food',
      'bulk_booking_container',
      'corporate_booking_container',
      'coupon_container_item',
      'trending_property_groups_container_item',
      'app_download_container',
      'home_page_policies_container',*/
      // 'dynamic_search_container',
    ];
    if (keys.includes(key)) {
      timeout = 2000;
    }

    return of(null).pipe(
      delay(timeout),
      switchMap(() => {
        return this.getComponentType(value, key);
      }),
    );
  }

  getComponentType(componentName: string, key: string): Observable<any> {
    switch (componentName) {
      case DYNAMIC_COMPONENTS.SmallPropertyCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-small-image-property-card/small-image-property-card/small-image-property-card.component'
          ).then((c) => c.SmallImagePropertyCardComponent),
        );
      case DYNAMIC_COMPONENTS.MobileLoginCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-mobile-login-card/b2b-mobile-login-card.component'
          ).then((c) => c.B2bMobileLoginCardComponent),
        );
      case DYNAMIC_COMPONENTS.HourPromotionComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-hour-promotion/b2b-hour-promotion.component'
          ).then((c) => c.B2bHourPromotionComponent),
        );
      case DYNAMIC_COMPONENTS.RoomComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-property-room-card/b2b-property-room-card.component'
          ).then((c) => c.B2bPropertyRoomCardComponent),
        );
      case DYNAMIC_COMPONENTS.MobileRoomComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-mobile-property-room-card/b2b-mobile-property-room-card.component'
          ).then((c) => c.B2bMobilePropertyRoomCardComponent),
        );
      case DYNAMIC_COMPONENTS.MobileIndianBannerCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-indian-banner-card/b2b-mobile-indian-banner-card/b2b-mobile-indian-banner-card.component'
          ).then((c) => c.B2bMobileIndianBannerCardComponent),
        );
      case DYNAMIC_COMPONENTS.DesktopIndianBannerCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-indian-banner-card/b2b-desktop-indian-banner-card/b2b-desktop-indian-banner-card.component'
          ).then((c) => c.B2bDesktopIndianBannerCardComponent),
        );
      case DYNAMIC_COMPONENTS.DesktopDiscoverIndiaComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-discover-card/desktop-discover-india/desktop-discover-india.component'
          ).then((c) => c.DesktopDiscoverIndiaComponent),
        );
      case DYNAMIC_COMPONENTS.MobileDiscoverIndiaComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-discover-card/mobile-discover-india/mobile-discover-india.component'
          ).then((c) => c.MobileDiscoverIndiaComponent),
        );

      case DYNAMIC_COMPONENTS.DesktopLoginPopoverComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-promotional-popovers/components/b2b-login-pop-over/b2b-login-pop-over.component'
          ).then((c) => c.B2bLoginPopOverComponent),
        );

      case DYNAMIC_COMPONENTS.MobileDownloadPopoverComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-promotional-popovers/components/b2b-mobile-download-pop-over/b2b-mobile-download-pop-over.component'
          ).then((c) => c.B2bMobileDownloadPopOverComponent),
        );

      case DYNAMIC_COMPONENTS.DesktopDownloadAppComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-download-app/b2b-desktop-download-app/b2b-desktop-download-app.component'
          ).then((c) => c.B2bDesktopDownloadAppComponent),
        );

      case DYNAMIC_COMPONENTS.AskReviewCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-ask-review-card/b2b-ask-review-card.component'
          ).then((c) => c.B2bAskReviewCardComponent),
        );

      case DYNAMIC_COMPONENTS.CancelButtonCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-cancel-button-card/b2b-cancel-button-card.component'
          ).then((c) => c.B2bCancelButtonCardComponent),
        );

      case DYNAMIC_COMPONENTS.ContactUsFormCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-contact-us-form-card/b2b-contact-us-form-card.component'
          ).then((c) => c.B2bContactUsFormCardComponent),
        );

      case DYNAMIC_COMPONENTS.PropertyCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-property-card/b2b-property-card.component'
          ).then((c) => c.B2bPropertyCardComponent),
        );
      case DYNAMIC_COMPONENTS.DesktopPropertyCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-desktop-property-card/b2b-desktop-property-card.component'
          ).then((c) => c.B2bDesktopPropertyCardComponent),
        );
      case DYNAMIC_COMPONENTS.DownloadVoucherCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-download-voucher-card/b2b-download-voucher-card.component'
          ).then((c) => c.B2bDownloadVoucherCardComponent),
        );
      case DYNAMIC_COMPONENTS.ShortBookingCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-short-booking-card/b2b-short-booking-card.component'
          ).then((c) => c.B2bShortBookingCardComponent),
        );
      case DYNAMIC_COMPONENTS.ErrorCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-error-card/b2b-error-card.component'
          ).then((c) => c.B2bErrorCardComponent),
        );
      case DYNAMIC_COMPONENTS.PropertiesNotFoundComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-error-cards/properties-not-found/properties-not-found.component'
          ).then((c) => c.PropertiesNotFoundComponent),
        );
      case DYNAMIC_COMPONENTS.LocalityPropertiesNotFoundComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-error-cards/locality-properties-not-found/locality-properties-not-found.component'
          ).then((c) => c.LocalityPropertiesNotFoundComponent),
        );

      case DYNAMIC_COMPONENTS.ContactUsCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-contact-us-card/b2b-contact-us-card.component'
          ).then((c) => c.B2bContactUsCardComponent),
        );
      case DYNAMIC_COMPONENTS.ThankYouCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-thankyou-card/b2b-thankyou-card.component'
          ).then((c) => c.B2bThankyouCardComponent),
        );

      case DYNAMIC_COMPONENTS.PendingCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-pending-card/b2b-pending-card.component'
          ).then((c) => c.B2bPendingCardComponent),
        );

      case DYNAMIC_COMPONENTS.CompletedCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-completed-card/b2b-completed-card.component'
          ).then((c) => c.B2bCompletedCardComponent),
        );

      case DYNAMIC_COMPONENTS.FailedCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-failed-card/b2b-failed-card.component'
          ).then((c) => c.B2bFailedCardComponent),
        );

      case DYNAMIC_COMPONENTS.DesktopProductCardFirstComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-desktop-product-card-first/b2b-desktop-product-card-first.component'
          ).then((c) => c.B2bDesktopProductCardFirstComponent),
        );
      case DYNAMIC_COMPONENTS.FirstProductCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-product-card-first/b2b-product-card-first.component'
          ).then((c) => c.B2bProductCardFirstComponent),
        );
      case DYNAMIC_COMPONENTS.SecondProductCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-product-card-second/b2b-product-card-second.component'
          ).then((c) => c.B2bProductCardSecondComponent),
        );
      case DYNAMIC_COMPONENTS.DesktopBookingProductCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-desktop-booking-product-card/b2b-desktop-booking-product-card.component'
          ).then((c) => c.B2bDesktopBookingProductCardComponent),
        );
      case DYNAMIC_COMPONENTS.ThirdProductCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-product-card-third/b2b-product-card-third.component'
          ).then((c) => c.B2bProductCardThirdComponent),
        );

      case DYNAMIC_COMPONENTS.FifthProductCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-product-card-fifth/b2b-product-card-fifth.component'
          ).then((c) => c.B2bProductCardFifthComponent),
        );
      case DYNAMIC_COMPONENTS.DesktopFifthProductCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-desktop-product-card-fifth/b2b-desktop-product-card-fifth.component'
          ).then((c) => c.B2bDesktopProductCardFifthComponent),
        );
      case DYNAMIC_COMPONENTS.ProductsByCategoryCard:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-products-by-category-card/b2b-products-by-category-card.component'
          ).then((c) => c.B2bProductsByCategoryCardComponent),
        );

      case DYNAMIC_COMPONENTS.DesktopProductsByCategoryCard:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-desktop-products-by-category-card/b2b-desktop-products-by-category-card.component'
          ).then((c) => c.B2bDesktopProductsByCategoryCardComponent),
        );

      case DYNAMIC_COMPONENTS.DesktopCouponCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-desktop-coupon-card/b2b-desktop-coupon-card.component'
          ).then((c) => c.B2bDesktopCouponCardComponent),
        );

      case DYNAMIC_COMPONENTS.LoginBenefitsCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-login-benefits-card/b2b-login-benefits-card.component'
          ).then((c) => c.B2bLoginBenefitsCardComponent),
        );

      case DYNAMIC_COMPONENTS.NgoCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-ngo-card/b2b-ngo-card.component'
          ).then((c) => c.B2bNgoCardComponent),
        );

      case DYNAMIC_COMPONENTS.PriceBreakupCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-price-breakup-card/b2b-price-breakup-card.component'
          ).then((c) => c.B2bPriceBreakupCardComponent),
        );

      case DYNAMIC_COMPONENTS.ShortPropertyCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-short-property-card/b2b-short-property-card.component'
          ).then((c) => c.B2bShortPropertyCardComponent),
        );

      case DYNAMIC_COMPONENTS.ShortPropertyCardComponentV1:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-short-property-card-v1/b2b-short-property-card-v1.component'
          ).then((c) => c.B2bShortPropertyCardV1Component),
        );

      case DYNAMIC_COMPONENTS.OverlayCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-overlay-card/b2b-overlay-card.component'
          ).then((c) => c.B2bOverlayCardComponent),
        );

      case DYNAMIC_COMPONENTS.StandardCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-standard-card/b2b-standard-card.component'
          ).then((c) => c.B2bStandardCardComponent),
        );

      case DYNAMIC_COMPONENTS.ShortStandardCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-short-standard-card/b2b-short-standard-card.component'
          ).then((c) => c.B2bShortStandardCardComponent),
        );

      /*case DYNAMIC_COMPONENTS.SecondSmallImageCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-small-image-card-second/b2b-small-image-card-second.component'
            ).then((c) => c.B2bSmallImageCardSecondComponent),
        );*/

      case DYNAMIC_COMPONENTS.SmallImageCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-small-image-card/b2b-small-image-card.component'
          ).then((c) => c.B2bSmallImageCardComponent),
        );
      case DYNAMIC_COMPONENTS.NewReviewCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-new-reviews-card/b2b-new-reviews-card.component'
          ).then((c) => c.B2bNewReviewsCardComponent),
        );
      case DYNAMIC_COMPONENTS.DynamicDataCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-dynamic-data-card/b2b-dynamic-data-card.component'
          ).then((c) => c.B2bDynamicDataCardComponent),
        );

      case DYNAMIC_COMPONENTS.LocationCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-location-card/b2b-location-card.component'
          ).then((c) => c.B2bLocationCardComponent),
        );
      /*case DYNAMIC_COMPONENTS.UserReviewCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/pages/b2b-user-review-card/b2b-user-review-card.component'
          ).then((c) => c.B2bUserReviewCardComponent)
        );*/

      case DYNAMIC_COMPONENTS.CustomerReviewComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-customer-review/customer-review/customer-review.component'
          ).then((c) => c.CustomerReviewComponent),
        );

      case DYNAMIC_COMPONENTS.RowItemComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-row-item/b2b-row-item.component'
          ).then((c) => c.B2bRowItemComponent),
        );

      case DYNAMIC_COMPONENTS.ShortLocationCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-short-location-card/b2b-short-location-card.component'
          ).then((c) => c.B2bShortLocationCardComponent),
        );

      case DYNAMIC_COMPONENTS.PromoComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-promotion/desktop-promo/desktop-promo.component'
          ).then((c) => c.DesktopPromoComponent),
        );

      case DYNAMIC_COMPONENTS.InformationCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-information-card/b2b-information-card.component'
          ).then((c) => c.B2bInformationCardComponent),
        );

      case DYNAMIC_COMPONENTS.ActivityInformationCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/activity-information-card/activity-information-card.component'
          ).then((c) => c.ActivityInformationCardComponent),
        );

      /*case DYNAMIC_COMPONENTS.SearchFormComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-search/pages/b2b-search-form/b2b-search-form.component'
          ).then((c) => c.B2bSearchFormComponent)
        );*/

      case DYNAMIC_COMPONENTS.SearchFormComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-search/components/b2b-mobile/b2b-mobile-shortstay-form/b2b-mobile-shortstay-form.component'
          ).then((c) => c.B2bMobileShortstayFormComponent),
        );

      case DYNAMIC_COMPONENTS.DesktopShortStaySearchFormComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-search/components/b2b-desktop/b2b-shortstay-form/b2b-shortstay-form.component'
          ).then((c) => c.B2bShortstayFormComponent),
        );

      case DYNAMIC_COMPONENTS.ItemListComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-item-list/b2b-item-list.component'
          ).then((c) => c.B2bItemListComponent),
        );

      case DYNAMIC_COMPONENTS.PopOverRoomGuestPickerComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-guest/components/b2b-popover-room-guest-field/b2b-popover-room-guest-field.component'
          ).then((c) => c.B2bPopoverRoomGuestFieldComponent),
        );

      case DYNAMIC_COMPONENTS.PopOverCalendarPickerComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-date-picker/components/b2b-popover-date-picker/b2b-popover-date-picker.component'
          ).then((c) => c.B2bPopoverDatePickerComponent),
        );

      case DYNAMIC_COMPONENTS.PopOverDateRangePickerComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-date-picker/components/b2b-popover-date-range-picker/b2b-popover-date-range-picker.component'
          ).then((c) => c.B2bPopoverDateRangePickerComponent),
        );

      case DYNAMIC_COMPONENTS.PopOverAutocompleteComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-autocomplete/components/b2b-popover-autocomplete/b2b-popover-autocomplete.component'
          ).then((c) => c.B2bPopoverAutocompleteComponent),
        );
      case DYNAMIC_COMPONENTS.InfiniteListComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-infinite-list/b2b-infinite-list.component'
          ).then((c) => c.B2bInfiniteListComponent),
        );
      case DYNAMIC_COMPONENTS.RadioListComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-new-radio-checkbox-list/b2b-new-radio-checkbox-list.component'
          ).then((c) => c.B2bNewRadioCheckboxListComponent),
        );
      case DYNAMIC_COMPONENTS.NewRadioCheckboxListComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-new-radio-checkbox-list/b2b-new-radio-checkbox-list.component'
          ).then((c) => c.B2bNewRadioCheckboxListComponent),
        );

      case DYNAMIC_COMPONENTS.SliderComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-sliders/components/b2b-sliders/b2b-sliders.component'
          ).then((c) => c.B2bSlidersComponent),
        );
      case DYNAMIC_COMPONENTS.ImageGalleryComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-gallery/components/b2b-image-gallery/b2b-image-gallery.component'
          ).then((c) => c.B2bImageGalleryComponent),
        );
      case DYNAMIC_COMPONENTS.ProductPriceBreakupCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-product-price-breakup-card/b2b-product-price-breakup-card.component'
          ).then((c) => c.B2bProductPriceBreakupCardComponent),
        );
      case DYNAMIC_COMPONENTS.RowLeftRightLayoutComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-layouts/components/b2b-row-left-right-layout/b2b-row-left-right-layout.component'
          ).then((c) => c.B2bRowLeftRightLayoutComponent),
        );
      case DYNAMIC_COMPONENTS.ContainerListShellComponent:
        return from(
          import(
            '@app/b2b-dynamic-lib/components/container-list-shell/container-list-shell.component'
          ).then((c) => c.ContainerListShellComponent),
        );
      case DYNAMIC_COMPONENTS.ContainerItemListShellComponent:
        return from(
          import(
            '@app/b2b-dynamic-lib/components/container-item-list-shell/container-item-list-shell.component'
          ).then((c) => c.ContainerItemListShellComponent),
        );

      case DYNAMIC_COMPONENTS.FooterButtonsComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-buttons/components/b2b-footer-button/b2b-footer-button.component'
          ).then((c) => c.B2bFooterButtonComponent),
        );
      case DYNAMIC_COMPONENTS.NewCheckboxListComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-new-checkbox-list/b2b-new-checkbox-list.component'
          ).then((c) => c.B2bNewCheckboxListComponent),
        );

      case DYNAMIC_COMPONENTS.ChipListComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-chip-list/b2b-chip-list.component'
          ).then((c) => c.B2bChipListComponent),
        );

      case DYNAMIC_COMPONENTS.RangeComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-range/components/b2b-range/b2b-range.component'
          ).then((c) => c.B2bRangeComponent),
        );

      case DYNAMIC_COMPONENTS.HeadingComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-typography/components/b2b-heading/b2b-heading.component'
          ).then((c) => c.B2bHeadingComponent),
        );

      case DYNAMIC_COMPONENTS.FilterButtonsComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-buttons/components/b2b-filter-buttons/b2b-filter-buttons.component'
          ).then((c) => c.B2bFilterButtonsComponent),
        );

      case DYNAMIC_COMPONENTS.InfiniteScrollComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-list/components/b2b-feature-list/feature-list-infinite-scroll/feature-list-infinite-scroll.component'
          ).then((c) => c.FeatureListInfiniteScrollComponent),
        );

      case DYNAMIC_COMPONENTS.DesktopFilterCardComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-cards/components/b2b-desktop-filter-card/b2b-desktop-filter-card.component'
          ).then((c) => c.B2bDesktopFilterCardComponent),
        );
      case DYNAMIC_COMPONENTS.CheckInTimeComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-checkin-time/b2b-checkin-time/b2b-checkin-time.component'
          ).then((c) => c.B2bCheckinTimeComponent),
        );
      case DYNAMIC_COMPONENTS.CheckInHourComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-checkin-hour/b2b-checkin-hour/b2b-checkin-hour.component'
          ).then((c) => c.B2bCheckinHourComponent),
        );

      case DYNAMIC_COMPONENTS.LandmarkComponent:
        return from(
          import(
            '@app/new-ui-lib/b2b-maps/landmark-autocomplete/landmark-autocomplete.component'
          ).then((c) => c.LandmarkAutocompleteComponent),
        );

      default:
        if (!environment?.production) {
          console.warn(
            'B2B_WARNING: Component detail is missing ',
            componentName,
            key,
          );
        }
        if (!this.b2bDeviceUtilService?.isServer()) {
          const element = this.document?.getElementById(key);

          if (element) {
            element.remove();
          }
        }

        return of(false);
    }
  }
}
